export default {
    menu:{
      config: "Configuración",
      cambiarPass: "Cambiar contraseña",
      cambiarFoto: "Cambiar foto de perfil",
      modoOscuro: "Modo oscuro",
      soporte: "Soporte",
      logout: "Cerrar sesión"
    },
    cuenta: {
        titulo: "Mi cuenta",
        tituloLargo: "Configuración de la cuenta",
        nombreTaller: "Nombre del taller",
        zonaHoraria: "Zona horaria",
        dominio: "Dominio"
    },
    deptos: {
        titulo: "Departamentos",
        nuevo: "Nuevo departamento",
        editar: "Editar departamento",
        eliminar: "Eliminar departamento",
        pregEliminar: "¿Confirmas que deseas eliminar el departamento?"
    },
    logos: {
        titulo: "Logo e impresión",
        logo: "Logo",
        logoDer: "Logo a la derecha",
        txtLegal: "Texto legal",
        txtCompra: "Texto de orden de compra",
        vias: "Vías",
        via: "Vía",
        impresionOrd: "Impresión para órdenes",
        impresionApp: "Impresión en la app",
        carta: "Carta",
        mismoEncabezado: "Utilizar el mismo encabezado de impresión en todas las sucursales"
    },
    correos: {
        titulo: "Diseño de correo",
        encabezado: "Encabezado",
        pie: "Pie de página",
        insertarImagen: "Insertar imagen"
    },
    servicios: {
        titulo: "Configuración de servicios",
        clienteValida: "El cliente valida con contraseña la apertura y cierre de servicios",
        tecnicoFallas: "El técnico debe registrar las fallas detectadas en la orden",
        tecnicoApertura: "El técnico debe realizar la apertura del servicio",
        clienteDispone: "El cliente dispone de",
        estadoReabrir: "días para reabrir un servicio. Al reabrirlo cambiar al estado ",
        visualizarPrev: "Visualizar servicios preventivos agendados con ",
        diasAnticipacion: " días de anticipación",
        estadoFinalizar: "Cuando se finaliza el servicio cambiar al estado ",
    },
    reparaciones: {
        titulo: "Configuración de reparaciones",
        estadoFinalizar: "Cuando se finaliza la reparación cambiar al estado",
        campoLibre: "Nombre de campo libre"
    },
    estadosServ: {
        titulo: "Estados de servicios",
        nuevo: "Nuevo estado",
        editar: "Editar estado",
        eliminar: "Eliminar estado de servicio",
        pregEliminar: "¿Confirmas que deseas eliminar el estado?",
        tarea: "Tarea a realizar cuando el servicio está en este estado"
    },
    estadosRep:{
        titulo: "Estados de reparaciones",
        nuevo: "Nuevo estado",
        editar: "Editar estado",
        eliminar: "Eliminar estado de reparación",
        pregEliminar: "¿Confirmas que deseas eliminar el estado?",
        tarea: "Tarea a realizar cuando la reparación está en este estado"
    },
    mantenimiento: {
        titulo: "Mantenimiento",
        gestores: "Gestores por área",
        sucursales: "Habilitar sucursales en equipos",
        moduloObras: "Habilitar módulo de Obras.",
        moduloVehicular: "Habilitar módulo de mantenimiento vehicular.",
        cambioAceite: "Alerta de cambio de aceite a los: ",
        kms: "Kms o a las: ",
        horas: "Horas",
        ver: "Visualizar mantenimientos agendados con",
        dias: "días de anticipación",
    },
    presupuesto: {
        titulo: "Configuración de presupuesto",
        concepto: "Utilizar conceptos de mano de obra en el presupuesto",
        precioAuto: "Habilitar precio automático por tipo de equipo en notas legales al imprimir",
        rma: "Incluir costo de RMA en el presupuesto",
        porDefecto: "Valor por defecto si no se ingresa el precio para un tipo de equipo:",
        cliente: "Si el cliente no responde el presupuesto en ",
        presup: " días pasar el presupuesto al estado: ",
        orden: " y la orden al estado: ",
        estadoPresup: "Estado de presupuesto",
        estadoOrden: "Estado de reparación"
    },
    categorias: {
        titulo: "Categorías",
        nueva: "Nueva categoría",
        editar: "Editar categoría",
        eliminar: "Eliminar categoría",
        pregEliminar: "¿Confirmas que deseas eliminar la categoría?"
    },
    impuestos: {
        titulo: "Impuestos",
        nuevo: "Nuevo impuesto",
        editar: "Editar impuesto",
        eliminar: "Eliminar impuesto",
        pregEliminar: "¿Confirmas que deseas eliminar el impuesto?",
        porcentaje: "Porcentaje"
    },
    repuestos: {
        titulo: "Configuración de repuestos",
        precio: "Precio a utilizar para los repuestos cuando se calcula el presupuesto: ",
        promedio: "Utilizar precio promedio ponderado en el costo de los artículos"
    },    
    cotizacion: {
        titulo: "Cotización de la moneda",
        nueva: "Nueva cotización",
        editar: "Editar cotización",
        compra: "Compra",
        venta: "Venta",
        eliminar: "Eliminar cotización",
        pregEliminar: "¿Confirmas que deseas eliminar la cotización?"
    
    },    
    manoObra: {
        titulo: "Conceptos de mano de obra",
        nueva: "Nueva mano de obra",
        editar: "Editar mano de obra",
        eliminar: "Eliminar mano de obra",
        pregEliminar: "¿Confirmas que deseas eliminar la mano de obra?"
    },    
    notificaciones: {
        titulo: "Notificaciones por e-Mail",
        mailCliente: "Envíar e-mail al cliente en cada cambio de estado de una orden",
        noMailTecnico: "No envíar e-mail al técnico y al gestor al ingresar una orden",
        noMailCliente: "No envíar e-mail al cliente al ingresar una orden",
        mailPresup: "Enviar e-mail con el presupuesto de órden de reparación a los clientes cada ",
        dias: " días"
    },    
    app: {
        titulo: "APP",
        tituloLargo: "Configuración de la APP",
        agregarEquipos: "Permitir agregar equipos"
    },    
    rubros: {
        titulo: "Rubros",
        nuevo: "Nuevo rubro",
        editar: "Editar rubro",
        eliminar: "Eliminar rubro",
        pregEliminar: "¿Confirmas que deseas eliminar el rubro?"
    },
    generadorQR: {
        titulo: "Generador de QR para reclamos",
        msgEquipo: "Selecciona un equipo para continuar",
        msgCliente: "Selecciona un cliente para continuar",
        equipo: "Equipo (opcional)",
        sinEquipo: "Activa esta opción si los reclamos no tienen un equipo asociado",
        registrarEquipo: "Registrar un nuevo equipo",
        buscarEquipo: "Buscar un equipo registrado",
        cliente: "Cliente (requerido)",
        registrarCliente: "Registrar un nuevo cliente",
        buscarCliente: "Buscar un cliente registrado",
        ubicacion: "Ubicación",
        sucursal: "Sucursal (opcional)",
        depto: "Departamento (opcional)",
    },    

}